import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import {DatePipe} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DialogService} from '../../../../../services/dialog/dialog.service';

@Component({
  imports: [
    FormsModule,
  ],
  providers: [DatePipe],
  templateUrl: './translation-import.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './translation-import.component.scss'
})
export class TranslationImportComponent implements Dialog {

  dataToImport: string = '';
  keyExpression: string = '';

  constructor(private dialog: DialogService) {
  }

  onDialogInit(params: DialogParams): void {
  }

  import(): void {
    const parsedData = JSON.parse(this.dataToImport.trim());
    const isObject = !Array.isArray(parsedData);

    const data = [];
    for (const key in parsedData) {
      data.push({
        key: this.keyExpression.replace('%i%', String(isObject ? key.toLowerCase() : (Number(key) + 1))),
        text: parsedData[key]
      });
    }

    this.dialog.closeDialog(data);
  }
}
